import { useContext } from "../Context"
import './ImageMatch.css'
import Modal from "./Modal"
import TopMatches from './TopMatches'
import { numToPercent } from "../constants"
import he from 'he'

const ImageMatch = () => {

    const { globalState, setGlobalState } = useContext()
    const { match, topMatches, isMatchLoading, timeTaken, devMode, progressUpdate, librarySize } = globalState

    return (
        <div className="position-relative">
            {isMatchLoading && (
                <div className="loading-container">
                    <div className='loading-overlay'>
                        <div className='spinner'></div>
                        {devMode && <p>{progressUpdate}</p>}
                    </div>
                </div>
            )}
            {match &&
                <div className='match'>
                    <h3>Your closest match:</h3>
                    <p><a className="App-link" href={match.url} target="_blank" rel="noreferrer">{he.decode(match.name)} {/* Decode HTML entities safely */}</a></p>
                    <div className="position-relative py2 similarity-container">
                        <img alt={match.name} src={match.thumbnail_url} />
                        {devMode && <div className="similarity">{numToPercent(match.similarity)}</div>}
                    </div>

                    {devMode && timeTaken && <p className="my0 py0 font-italic text-sm">{timeTaken.toFixed(2)} seconds </p>}
                    {devMode && librarySize && <p className="my0 py0 font-italic text-sm">{librarySize} images in library </p>}
                </div>
            }
            {topMatches && topMatches.length > 0 &&
                <div className="cursor-pointer explore-matches" onClick={() => setGlobalState({ ...globalState, showModal: true })}>
                    Explore more matches
                    <div className="matches-preview">
                        {topMatches && topMatches.length > 0 ? (
                            <ul>
                                {topMatches.slice(1).map((match, index) => ( // Exclude the first match by slicing the array
                                    <li key={index}>

                                        <img alt={match.name} src={match.thumbnail_url} />

                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            }
            <Modal>
                <TopMatches />
            </Modal>
        </div>
    )
}

export default ImageMatch